import { getCriterion } from "../../api/apiCriteria";
import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
import logoImage from "../../assets/img/logobase64";

const saveAsPDF = async (
  tableData,
  inputData,
  criteriaSelected,
  alternativesNames
) => {
  let criteriaWithData = await Promise.all(
    criteriaSelected.map(async (criterionId) => {
      return await getCriterion(criterionId);
    })
  );

  const date = new Date();
  //const formattedDate = `${date.toLocaleDateString()} ${date.toLocaleTimeString()}`;
  const formattedDate = new Intl.DateTimeFormat('en-GB', { 
    day: '2-digit', 
    month: '2-digit', 
    year: 'numeric', 
    hour: '2-digit', 
    minute: '2-digit', 
    second: '2-digit', 
    hour12: false 
}).format(date);

  // Header section
  const header = (currentPage, pageCount) => {
    return [
      {
        columns: [
          { image: logoImage, width: 50 }, // Adjust the image size
          {
            text: "FRUITrank\nREZULTATI RANGIRANJA",
            alignment: "center",
            margin: [10, 0, 0, 0],
            color: "green",
            fontSize: 16,
            bold: true,
          },
        ],
        margin: [30, 10],
      },
      {
        text: `Stranica ${currentPage} od ${pageCount}`,
        alignment: "right",
        margin: [0, 10],
      },
    ];
  };

  // Footer section
  const footer = (currentPage, pageCount) => {
    return {
      columns: [
        { text: `Generisano: ${formattedDate}`, alignment: "left" },
        { text: `Stranica ${currentPage} od ${pageCount}`, alignment: "right" },
      ],
      margin: [40, 10, 40, 0],
    };
  };

  // Input data table
  const inputColumnHeaders = [
    { text: "Alternative", bold: true },
    ...criteriaWithData.map((criterion) => ({
      text: criterion?.oznaka,
      bold: true,
    })),
  ];

  const inputRows = inputData.map((row, rowIndex) => [
    { text: alternativesNames[rowIndex] }, // Alternatives
    ...row.map((cell) => ({ text: cell.toString() })),
  ]);

  // Results table
  const tableColumnHeaders = [
    { text: "RB", bold: true },
    { text: "Naziv", bold: true },
    { text: "Vrijednost funkcije korisnosti", bold: true },
    { text: "Rang", bold: true },
  ];

  const tableRows = tableData.map((row, rowIndex) => [
    { text: (rowIndex + 1).toString() },
    { text: row[0] },
    { text: row[1].toString() },
    { text: row[2].toString() },
  ]);

  // Legend section
  const legend = criteriaWithData
    .map((criteria) => `${criteria?.oznaka} - ${criteria?.naziv}`)
    .join("\n");

  const docDefinition = {
    pageSize: "A4",
    pageMargins: [40, 60, 40, 60],
    header: header,
    footer: footer,
    content: [
      { text: "Unesene vrijednosti:", style: "header", margin: [0, 10, 0, 10] },
      {
        table: {
          headerRows: 1,
          widths: Array(inputColumnHeaders.length).fill("auto"),
          body: [inputColumnHeaders, ...inputRows],
        },
        layout: "lightHorizontalLines",
        margin: [0, 10, 0, 20],
      },
      { text: "Dobijeni rezultati:", style: "header", margin: [0, 10, 0, 10] },
      {
        table: {
          headerRows: 1,
          widths: ["auto", "auto", "auto", "auto"],
          body: [tableColumnHeaders, ...tableRows],
        },
        layout: "lightHorizontalLines",
        margin: [0, 10, 0, 20],
      },
      { text: legend, style: "legend", margin: [0, 20, 0, 20] },
    ],
    styles: {
      header: {
        fontSize: 14,
        bold: true,
      },
      legend: {
        fontSize: 10,
      },
    },
  };

  // Generate the PDF and trigger the download
  pdfMake.createPdf(docDefinition).download("rangiraneAlterantive.pdf");
};

export default saveAsPDF;

